export default __webpack_public_path__ + "static/media/f-arrow.4cefa636.svg";